import React from "react";
import ListItemText from "@material-ui/core/ListItemText";
import {CountdownTimer} from "./CountdownTimer";
import {BASE_URL_API} from "../Const";

export class LotteryComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lotteryInfo: {},
        }
    }

    componentDidMount() {
        fetch(BASE_URL_API+ 'lottery', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code == '200') {
                        this.setState({lotteryInfo: results.data})
                    }

                },
                (error) => {
                    console.log("error")
                }
            );
    }

    diffDate(date){
        if (date==null) return 0

        const today=new Date()
        const date2 = new Date(Date.parse(date));

       return parseInt((date2.getTime()-today.getTime())/1000)
    }

    render() {

        return (
            <div style={{width: window.innerWidth, height: window.innerHeight}}>
                <video style={{width: "100%", height: "100%", objectFit: "cover",margin:0,padding:0}} autoPlay muted loop
                       src="http://hamekara.com/lottery_loop.mp4"/>
                <ListItemText>

                    <div style={{
                        position: "absolute",
                        width: '100%',
                        height: '100%',
                        top: 0,
                        display: "flex",
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: 'white'
                    }}>
                        <p style={{ fontSize: window.innerWidth/15}}>قرعه کشی بزرگ سالن رویانا</p>
                        {this.diffDate(this.state.lotteryInfo.end_time)>0 ?  <CountdownTimer startTimeInSeconds={this.diffDate(this.state.lotteryInfo.end_time)}/> : <p/>}


                        <p  align='center' style={{ fontSize: 18}}>سه پک کامل لوازم آرایشی به ارزش 100 میلیون ریال برای سه نفر.<br/> سوپر اپلیکیشن همه کارا</p>

                    </div>


                </ListItemText>

            </div>


        );

    }

}
